import React from "react";

const ReminderHero = ({
  onAddReminder,
  onViewList,
  onViewCreatedAt,
  activePage,
  onViewBulk,
}) => {
  return (
    // Changed to white background with a very subtle bottom border
    <section className="py-2 bg-white border-bottom">
      <div className="container text-center py-5">
        {/* Modernized Heading with a gradient or simple dark color */}
        <h1 className="fw-bold display-5 text-dark mb-2">Reminder</h1>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center mb-4">
            <li className="breadcrumb-item">
              <a href="/" className="text-muted text-decoration-none">
                Home
              </a>
            </li>
            <li
              className="breadcrumb-item active text-primary fw-semibold"
              aria-current="page"
            >
              Reminder
            </li>
          </ol>
        </nav>

        {/* Action Buttons with Shadow and Modern Hover States */}
        <div className="mt-4 d-flex flex-column flex-md-row justify-content-center gap-3">
          <button
            className={`fw-bold px-4 py-2 rounded-pill transition-all ${
              activePage === "form"
                ? "btn btn-primary shadow-sm w-100 w-md-auto"
                : "btn btn-outline-secondary opacity-75 w-100 w-md-auto"
            }`}
            onClick={onAddReminder}
            style={{ transition: "0.3s" }}
          >
            ➕ Add Reminder
          </button>

          <button
            className={`fw-bold px-4 py-2 rounded-pill transition-all ${
              activePage === "list"
                ? "btn btn-primary shadow-sm w-100 w-md-auto"
                : "btn btn-outline-secondary opacity-75 w-100 w-md-auto"
            }`}
            onClick={onViewList}
            style={{ transition: "0.3s" }}
          >
            📋 Reminder List
          </button>

          <button
            className={`fw-bold px-4 py-2 rounded-pill transition-all ${
              activePage === "createdAt"
                ? "btn btn-primary shadow-sm w-100 w-md-auto"
                : "btn btn-outline-secondary opacity-75 w-100 w-md-auto"
            }`}
            onClick={onViewCreatedAt}
            style={{ transition: "0.3s" }}
          >
            🗓️ CreatedAt List
          </button>

          <button
            className={`fw-bold px-4 py-2 rounded-pill transition-all ${
              activePage === "bulk"
                ? "btn btn-primary shadow-sm w-100 w-md-auto"
                : "btn btn-outline-secondary opacity-75 w-100 w-md-auto"
            }`}
            onClick={onViewBulk}
            style={{ transition: "0.3s" }}
          >
            📢 Bulk Send
          </button>
        </div>
      </div>
    </section>
  );
};

export default ReminderHero;
